var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsultancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#a9d0e0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.17,85.57h-21.16v-5.6c0-5.84,4.74-10.58,10.58-10.58h0c5.84,0,10.58,4.74,10.58,10.58v5.6Z",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.31,62.9c0,3.58-2.91,6.49-6.49,6.49s-6.49-2.91-6.49-6.49,2.91-6.49,6.49-6.49,6.49,2.91,6.49,6.49Z",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.02,68.66c1.92-2.63,5.04-4.35,8.55-4.35h0c5.84,0,10.58,4.74,10.58,10.58v10.67h-16.98",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.29,57.83c0,3.58-2.91,6.49-6.49,6.49s-6.49-2.91-6.49-6.49,2.91-6.49,6.49-6.49,6.49,2.91,6.49,6.49Z",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.63,68.66c-1.92-2.63-5.04-4.35-8.55-4.35h0c-5.84,0-10.58,4.74-10.58,10.58v10.67h16.51",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.36,57.83c0,3.58,2.91,6.49,6.49,6.49s6.49-2.91,6.49-6.49-2.91-6.49-6.49-6.49-6.49,2.91-6.49,6.49Z",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.31,47.37v-4.29l3.03-.39c.35-1.24.83-2.41,1.45-3.51l-1.86-2.43,6.04-6.04,2.43,1.87c1.1-.61,2.27-1.1,3.51-1.46l.39-3.04h8.56l.4,3.04c1.24.36,2.41.85,3.51,1.46l2.43-1.87,6.04,6.04-1.87,2.44c.6,1.1,1.1,2.27,1.44,3.5l3.06.39v4.29",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.33,47.37c0-6.22,5.04-11.26,11.26-11.26s11.26,5.04,11.26,11.26",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultancy);
export default __webpack_public_path__ + "static/media/consultancy.6425025f12dc99cb074d1ba60876b8b7.svg";
export { ForwardRef as ReactComponent };